import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  AppStateService,
  ProfileService,
  RedirectService,
  StorageService,
} from '@services';
import { Logger } from '@utils/logger';
import { take } from 'rxjs/operators';
import { combineLatest, from } from 'rxjs';

const logger = Logger.getLogger('Auth0LoginCallbackComponent');

@Component({
  selector: 'ft-auth0-login-callback',
  templateUrl: './auth0-login-callback.component.html',
  styleUrls: ['./auth0-login-callback.component.scss'],
})
export class Auth0LoginCallbackComponent implements OnInit {
  constructor(
    private router: Router,
    private storageService: StorageService,
    private appStateService: AppStateService,
    private profileService: ProfileService,
    private redirectService: RedirectService
  ) {}

  ngOnInit(): void {
    combineLatest([
      this.profileService.getUserProfile$(),
      from(this.storageService.getAuth0CallbackRoute()),
    ])
      .pipe(take(1))
      .subscribe(([profile, callbackRoute]) => {
        if (!this.redirectUserToAccounts(profile)) {
          const route = callbackRoute || this.appStateService.getSpaBaseUrl();
          this.redirectService.getRedirect(route).then((redirectedRoute) => {
            if (redirectedRoute) {
              this.router.navigate([redirectedRoute]);
            } else {
              this.router.navigate([route]);
            }
          });
        }
      });
  }

  redirectUserToAccounts(profile) {
    // TODO
    // if current url is home page && user is Investor and user has accounts and dashboardUrl is set
    // then redirect to accounts
    return false;
  }
}
